import { useEffect, useRef, useState } from "react";
import axios from "axios";
import AddProductModal from "../components/AddProductModal";
import UpdateProductModal from "../components/UpdateProductModal";
import Pagination from "../components/Pagination";

export default function Inventory(params) {
  const [productsData, setProductsData] = useState([]);
  const [storesData, setStoresData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 6;
  const lastIndex = currentPage * recordsPerPage;
  const startingIndex = lastIndex - recordsPerPage;
  const records = productsData.slice(startingIndex, lastIndex);

  const paginationRef = useRef(null);

  useEffect(() => {
    if (paginationRef.current) {
      paginationRef.current.update(currentPage);
    }
  }, [currentPage]);

  const changeCurrPage = (num) => {
    setCurrentPage(num);
  };

  useEffect(() => {
    fetchProducts();
    fetchStores();
    // console.log(storesData);
  }, []);

  const fetchStores = async () => {
    try {
      const res = await axios.get(
        "https://buttery-substantial-helicopter.glitch.me/stores"
      );
      setStoresData(res.data);
      // console.log(res.data);
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const manufacturers = productsData.map((item) => {
    return item.manufacturer;
  });
  const revenue = storesData.map((item) => {
    return item.sell;
  });
  const inStock = productsData.filter((item) => {
    return item.stock > 0;
  });
  const notInStock = productsData.filter((item) => {
    return item.stock === 0;
  });

  const TotalManufacturers = [...new Set(manufacturers)];

  const fetchProducts = async () => {
    try {
      const res = await axios.get(
        "https://buttery-substantial-helicopter.glitch.me/products"
      );
      setProductsData(res.data);
      console.log(res.data);
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const deleteProducts = async (id) => {
    console.log(id);

    if (window.confirm("Are you sure?")) {
      try {
        const response = await axios.delete(
          `https://buttery-substantial-helicopter.glitch.me/products/${id}`
        );
        fetchProducts();
        alert(response.data.message);
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <div className="w-full px-4 py-5 bg-white rounded-lg shadow">
        <h2 className=" text-gray-800 font-semibold truncate">
          Overall Inventory
        </h2>
        <div className="mt-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          <div className="m-3 p-1">
            <h3 className="text-blue-500 font-semibold">Manufacturer</h3>
            <div className="text-gray-600 mt-1 font-semibold">
              {TotalManufacturers.length}
            </div>
          </div>
          <div className="m-3 p-1">
            <h3 className="text-orange-500 font-semibold">Total Products</h3>
            <div className="flex">
              <span className="mr-8">
                <div className="text-gray-600 mt-1 font-semibold">
                  {productsData.length}
                </div>
              </span>
              <span>
                <div className="text-gray-600 mt-1 font-semibold">
                  {/* {revenue.reduce((a, c) => a + c)} */}
                  {revenue.reduce(function (prev, cur) {
                    return prev + cur;
                  }, 0)}
                </div>
                <span className="text-gray-400 text-sm">Revenue</span>
              </span>
            </div>
          </div>
          {/* <div className="m-3 p-1">
            <h3 className="text-purple-500 font-semibold">Top Selling</h3>
            <div className="flex">
              <span className="mr-8">
                <div className="text-gray-600 mt-1 font-semibold">5</div>
              </span>
              <span>
                <div className="text-gray-600 mt-1 font-semibold">Rs2500</div>
                <span className="text-gray-400 text-sm">Cost</span>
              </span>
            </div>
          </div> */}
          <div className="m-3 p-1">
            <h3 className="text-red-500 font-semibold">Stocks</h3>
            <div className="flex">
              <span className="mr-8">
                <div className="text-gray-600 mt-1 font-semibold">
                  {inStock.length}
                </div>
                <span className="text-gray-400 text-sm">In Stock</span>
              </span>
              <span>
                <div className="text-gray-600 mt-1 font-semibold">
                  {notInStock.length}
                </div>
                <span className="text-gray-400 text-sm">Not in stock</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-4 py-5 my-3 bg-white rounded-lg shadow">
        {/* <div className="flex justify-between align-middle">
          <h2 className=" text-gray-800 font-semibold truncate">Products</h2>

          <div className="flex gap-8 align-middle">
            <div className="relative top-2 flex align-middle"></div>
          </div>
        </div> */}

        <div className="overflow-x-auto mt-2">
          <div className="max-w-screen-xl mx-auto px-4">
            <div className="items-start justify-between md:flex">
              <div className="max-w-lg">
                <h3 className="text-gray-800 text-xl font-bold sm:text-2xl">
                  Products
                </h3>
              </div>
              <div className="mt-3 md:mt-0 flex align-middle">
                <details className="group relative top-2 flex align-middle mr-4 [&_summary::-webkit-details-marker]:hidden">
                  <summary className="flex items-center gap-2 pb-1 text-gray-900 transition cursor-pointer">
                    <span className="text-sm font-medium"> Availability </span>

                    <span className="transition group-open:-rotate-180">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        // stroke-width="1.5"
                        stroke="currentColor"
                        className="w-4 h-4"
                      >
                        <path
                          // stroke-linecap="round"
                          // stroke-linejoin="round"
                          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                        />
                      </svg>
                    </span>
                  </summary>

                  <div className="z-50 group-open:absolute group-open:top-auto right-0 group-open:mt-2">
                    <div className="bg-white border border-gray-200 rounded w-96">
                      <header className="flex items-center justify-between p-4">
                        <span className="text-sm text-gray-700">
                          {" "}
                          0 Selected{" "}
                        </span>

                        <button
                          type="button"
                          className="text-sm text-gray-900 underline underline-offset-4"
                        >
                          Reset
                        </button>
                      </header>

                      <ul className="p-4 space-y-1 border-t border-gray-200">
                        <li>
                          <label
                            htmlFor="FilterInStock"
                            className="inline-flex items-center gap-2"
                          >
                            <input
                              type="checkbox"
                              id="FilterInStock"
                              className="w-5 h-5 border-gray-300 rounded"
                            />

                            <span className="text-sm font-medium text-gray-700">
                              In Stock (5+)
                            </span>
                          </label>
                        </li>

                        <li>
                          <label
                            htmlFor="FilterPreOrder"
                            className="inline-flex items-center gap-2"
                          >
                            <input
                              type="checkbox"
                              id="FilterPreOrder"
                              className="w-5 h-5 border-gray-300 rounded"
                            />

                            <span className="text-sm font-medium text-gray-700">
                              Pre Order (3+)
                            </span>
                          </label>
                        </li>

                        <li>
                          <label
                            htmlFor="FilterOutOfStock"
                            className="inline-flex items-center gap-2"
                          >
                            <input
                              type="checkbox"
                              id="FilterOutOfStock"
                              className="w-5 h-5 border-gray-300 rounded"
                            />

                            <span className="text-sm font-medium text-gray-700">
                              Out of Stock (10+)
                            </span>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </details>
                <AddProductModal fetchProducts={fetchProducts} />
              </div>
            </div>
            <div className="mt-5 shadow-sm border rounded-lg overflow-x-auto">
              <table className="w-full table-auto text-sm text-left">
                <thead className=" text-gray-600 font-medium border-b">
                  <tr>
                    <th className="py-3 px-6">Product Code</th>
                    <th className="py-3 px-6">Product Name</th>
                    <th className="py-3 px-6">Manufacturer</th>
                    <th className="py-3 px-6">Stock</th>
                    <th className="py-3 px-6">Added Date</th>
                    <th className="py-3 px-6">Modified Date</th>
                  </tr>
                </thead>
                <tbody className="text-gray-600 divide-y">
                  {records.map((item) => (
                    <tr key={item._id} className="hover:bg-gray-100">
                      <td className="px-6 py-4 whitespace-nowrap">
                        #{item._id.slice(-6)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {item.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {item.manufacturer}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {item.stock}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {item.createdAt.slice(0, 10)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {item.updatedAt.slice(0, 10)}
                      </td>
                      <td className="text-right px-6 whitespace-nowrap">
                        {/* <button className="py-2 px-3 font-medium text-indigo-600 hover:text-indigo-500 duration-150 hover:bg-gray-50 rounded-lg">
                          Edit
                        </button> */}
                        <UpdateProductModal
                          pid={item._id}
                          pname={item.name}
                          pmanufacturer={item.manufacturer}
                          pstock={item.stock}
                        />
                        <button
                          onClick={() => deleteProducts(item._id)}
                          className="py-2 leading-none px-3 font-medium text-red-600 hover:text-red-500 duration-150 hover:bg-red-100 rounded-lg"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagination
              ref={paginationRef}
              currentPage={currentPage}
              changeCurrPage={changeCurrPage}
              totalData={productsData.length}
              recordsPerPage={recordsPerPage}
            />
          </div>
        </div>
      </div>
    </>
  );
}
